import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import IPageList from 'src/dataModel/IPageList';
import IPagenation from 'src/dataModel/IPagenation';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic implements IPageList <IParamCondition> {  
    /** 列表数据 */
    public list: any = [];

    public pagination: IPagenation = {
        total: 0,
        current: 1,
        defaultCurrent: 1,
        pageSize: 20,
        onChange: () => { console.log(''); }
    };

    /** 滚动加载更多 */
    public hasMoreItems: boolean = true;
    public paramCondition: IParamCondition = {};
}
interface IParamCondition { 
    city?: string;
    connectionTaxId?: string;
    contractUser?: string; 
    country?: string;
    fuzzyConnectionName?: string;
    labelIds?: number[];
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/Modules.State.adminmylist.ts